export default{
  top1: '概览',
  top2: '技术规格',
  dec: 'Capture the World in 3D with Eight-Lens HD Camera',
  yushou: '【Item Price】',
  price: 'USD 1799',
  addzhijia: 'RMB 10,395',
  buy: 'Buy it on Alibaba',
  tiaokuan: '',
  why: ' Why do I need to purchase storage capacity?',
  guige: {
    name: 'Product Specifications',
    dec: 'Note: All configurations and specifications listed on this page shall prevail the actural product launched to the market, and are subject to alteration without notice.',
    arr: [
      {
        name: 'Size',
        val: ['Height: 220.7mm', 'Diameter: 78.2mm']
      },
      {
        name: 'Lens',
        val: [
          'Type: 200° Fish-Eye lens',
          'Apperture Value: f/2.0',
          'Amount: 8',
          'Image Resolution: 4608x3456(single); 8192x4096(total)'
        ]
      },
      {
        name: 'Sensor',
        val: ['Range: 1/2.3 inch', 'Amount: 8']
      },
      {
        name: 'Storage Capacity',
        val: [
          '16GB'
        ]
      },
      {
        name: 'Battery',
        val: [
          '7.4V 4200mAh',
          'Speed charging via USB cable'
        ]
      },
      {
        name: 'WiFi',
        val: [
          '802.11a/b/g/n network protocol',
          'Supports 2.4/5GHz telecommunications'
        ]
      },
      {
        name: 'Device Port',
        val: [
          'TYPE C'
        ]
      }
    ]
  },
  color: {
    key: 'color',
    val: 'Night Sky Black'
  },
  service: {
    type: 'Storage Capacity Plan (10GB)',
    key: 'Service',
    val: [
      'Supports sharing on various social media platforms',
      'Upload speed up to 6 M/s',
      'Supports adding multimedia hotspots, privacy encryption, automatic distance measurement and embedding website links in 3D spaces.'
    ]
  },
  gift: {
    peijian: 'Feature Kit',
    key: 'Learn more about the Feature Kit',
    val: '4D KanKan Pro Tripot Set',
    price: 'USD：209'
  },
  count: {
    key: 'Amount'
  },
  pricename: 'Details of cloud capacity expansion',
  pricename1: 'Details of cloud capacity expansion',
  pricelist: {
    0: 'Type',
    1: 'Storage capacity package',
    2: 'Price',
    3: 'Monthly',
    4: 'Annually',
    5: 'Basic Storage capacity',
    6: '10G',
    7: '—',
    8: 'Storage capacity expansion',
    9: '20G',
    10: '50G',
    11: '200G',
    12: '1T',
    13: '$19/mon.',
    14: '$76/mon.',
    15: '$349/mon.',
    16: '$1799/mon.',
    17: '$190/year',
    18: '$760/year',
    19: '$3490/year',
    20: '$17990/year',
    '13hw': '$19/mon.',
    '14hw': '$76/mon.',
    '15hw': '$349/mon.',
    '16hw': '$1799/mon.',
    '17hw': '$190/year',
    '18hw': '$760/year',
    '19hw': '$3490/year',
    '20hw': '$17990/year',
    21: 'If you want topurchase more than 1T, please contact customer service.'

  },
  pricetxt: [
    {
      q: 'Why do I need cloud storage?',
      a:
        'As a 3D camera, 4D KanKan has an algorithm which is different from those in conventional 2D camera. The computing results cannot be saved locally.<br/>As the AI space reconstruction algorithm system of 4D KanKan requires huge computing resource support, a costly host is needed at the local end for quick computing. Thus, we deploy the computing on the cloud server. The cloud service for computing and storage can both reduce the cost and provide an enterprise-level data protection. Meanwhile, the computing results can be browsed on multiple ports (mobile, web, IPAD, VR) without plugins.'
    },
    {
      q: 'Why do I need to purchase additional memory capacity?',
      a:
        'The basic storage capacity is 10 GB, which is sufficient for approximately 10 3D scenes and each scene is up to 200 ㎡.<br/>When the  basic storage capacity cannot meet your need anymore, extra capacity is to be purchased. Storage capacity expansion allows you obtain larger capacity which means you may capture, upload, compute, and view more scenes data.<br/>The generation and storage of 3D scenes and models consume a lot of computing and memory resources, which cannot be realized only by the hardware devices that come with the camera. Massive data operations and storage are conducted on the public cloud of object storage service (OSS). When computing and storing more 3D scenes, more cloud resources are consumed, thus the capacity expansion would be charged.'
    }
  ],
  notice: '',
  view: 'View the detailed camera storage capacity expansion plan pricing.',
  qa: [
    {
      q: 'Why do I need cloud storage?',
      a:
        `As a 3D camera, 4D KanKan has an algorithm which is different from those in conventional 2D camera. The computing results cannot be saved locally.<br/>
        As the AI space reconstruction algorithm system of 4D KanKan requires huge computing resource support, a costly host is needed at the local end for quick computing. Thus, we deploy the computing on the cloud server. The cloud service for computing and storage can both reduce the cost and provide an enterprise-level data protection. Meanwhile, the computing results can be browsed on multiple ports (mobile, web, IPAD, VR) without plugins.`
    },
    {
      q: 'Why do I need to purchase additional memory capacity?',
      a: `The basic storage capacity is 10 GB, which is sufficient for approximately 10 3D scenes and each scene is up to 200 ㎡.<br/>
      When the basic storage capacity cannot meet your need anymore, extra capacity is to be purchased. Storage capacity expansion allows you obtain larger capacity which means you may capture, upload, compute, and view more scenes data.<br/>
      The generation and storage of 3D scenes and models consume a lot of computing and memory resources, which cannot be realized only by the hardware devices that come with the camera. Massive data operations and storage are conducted on the public cloud of object storage service (OSS). When computing and storing more 3D scenes, more cloud resources are consumed, thus the capacity expansion would be charged.`
    },
    {
      q: 'What is the basic storage capacity? What is the expanded capacity? ',
      a: `The basic storage capacity is the free 10G capacity that comes with the camera purchase. The expanded capacity means the additional storage capacity purchased when the basic capacity cannot meet your needs. You can expand the capacity by purchasing more storage space, in order to capture, upload, calculate, and browse more data from captured scenes.`
    },
    {
      q: 'How to expand memory capacity? ',
      a:
        `After registration and bounding your membership with the camera, you can successively click on the [Personal Center (click on the user's avatar at the upper right corner -)] - [My Cameras] - [Expansion] to complete the expansion of the storage.<br/>
        You may also expand the storage plan from the camera app. Enter [Me] and click [Expansion]`
    },
    {
      q: 'What are the time periods for storage capacity expansion?',
      a: `The expanded storage capacity takes place immediately after you successfully purchase a package. The validity period of the package is either a year or a month. The annual capacity validity period is calculated as 365 days, and the monthly capacity validity period is calculated as 31 days.<br/>
      When you purchase a package, the expiration time is calculated as follows:<br/>
      If you purchased a one-year package on August 26, 2019, you can use it until 23:59, August 25, 2020.`
    },
    {
      q: 'Can the same package be purchased repeatedly? ',
      a: `No. The purchase of the same capacity package can only be renewed. If you need a larger capacity package, you can upgrade your current package.`
    },
    {
      q: 'Can the capacities of different packages be purchased together?',
      a:
        `No. If you need a larger capacity package, you can upgrade your current package.`
    },
    {
      q: 'If I upgrade the package, what happens to the remaining time of the original package?',
      a:
        `The remaining time of the original package will be converted into the time of the new package, which will be reflected as an extension time.<br/>
        The calculation formula is based on a 20G package(USD 19 per month), 10G of which is the base capacity and the unit value of conversion is about USD 0.06 / day / GB.<br/>
        If your original package is a 20G package (month) and there are 10 days left to expiration, the remaining balance is calculated as USD 6.<br/>
        Your upgrade package for that day is a 50G package (month), and its cost is USD 69 yuan / month (single day value is USD 2.22).<br/>
        The remaining value of the original package is about 2.7 times of the one-day value of the new package, and the new package is extended for 3 days.<br/>
        (The deferred charging method uses a further method: 1.01 ~ 1.99 multiples are considered as double.)`
    },
    {
      q: 'Can the capacity plan be downgraded? ',
      a:
        `Downgrading process is currently not supported. That is, the 50G package / month cannot be upgraded or renewed by selecting the 10G package / month by clicking "Upgrade Package". If your expansion capacity exceeds 1TB, please contact customer service.`
    },
    {
      q: 'What happens to the scenes in the current storage capacity once a storage expansion service expires? ',
      a:
        `When the expansion service expires, the expired storage capacity will be taken back.<br/>
        After the storage capacity is expired, if the total data size doesn’t exceed the current storage capacity, the scenes will not be affected. Otherwise, the scenes will be archived. This means that the functions such as browsing, editing, and sharing will be temporarily unavailable. The scenes that have not been archived will not be affected. The order of archiving is the reverse order of the time sequence of the scenes. That is, the most recently generated scene is first one to be archived. The archived data will be stored in the cloud for one year.`
    },
    {
      q: 'Can I continue to upload scenes when exceeding the memory capacity?',
      a:
        `When the storage capacity is exceeded, you can still shoot photos with the device and upload them. However, the newly uploaded scenes will be archived until the available storage capacity is bigger than or equal to the total data size of the scenes.`
    },
    {
      q: 'How can I recover the archived scenes?',
      a:
        `When you continue purchasing the expanded capacity until the storage capacity is bigger than or equal to the total data size of the scenes, the archived scenes will be recovered. In addition, the recover of the archived scenes can also be achieved by deleting the scenes no longer needed. The deleted scenes will not be restored.<br/>
        The above contents, charging standards and fee structure may be altered according to the rate changes or operating policies of the third-party cloud storage.<br/>
        Any adjustment will be announced on the official website without prior notice.`
    }
  ],
  directions: 'Directions:',
  read1: 'The above contents and charging standards fee structure may be altered according to the cost changes or operating policies of the third-party cloud storage.',
  read2: 'Any adjustment will be announced on the official website without prior notice.',
  introduce: {
    deviceId: 'Device ID: ',
    used: 'Already used:',
    taocan: '',
    belong: 'Storage Capacity: ',
    scence: 'My scenes',
    buyType: 'Please select the package type',
    mounthly: '1 mon.',
    _3month: '3 mon.',
    half: '6 mon.',
    year: '1 year',
    buy: 'Upgrade package',
    nyear: 'year',
    nmounth: 'month',
    fixpre: {
      month: '1 mon.',
      year: '1 year',
      _3mon: '3 mon.',
      half: '6 mon.'
    },
    spaceContent: '4DKanKan Pro basic storage capacity',
    ctype: {
      '10GB': 'About 10 3D scenes',
      '20GB': 'About 20 3D scenes',
      '50GB': 'About 50 3D scenes',
      '50G': 'About 50 3D scenes',
      '200GB': 'About 200 3D scenes',
      '1TB': 'About 1000 3D scenes'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/language/en/purchase.js